/**
 * @namespace {BX.UI}
 */
export default class ButtonTag
{
	static BUTTON = 0;
	static LINK = 1;
	static SUBMIT = 2;
	static INPUT = 3;
	static DIV = 4;
	static SPAN = 5;
}